/* @flow */
import React from 'react';
// $FlowIgnore
import { MdLock } from 'react-icons/md';

export default function SubmittedIcon({
  style
}: Object): React.Element {
  return <MdLock style={style} />;
}
